import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Layers, Brain, ShieldCheck, Boxes, Landmark, GraduationCap, ArrowUpRight, Check } from 'lucide-react';
import { SERVICE_ROUTES } from '@/i18n.services';

const ICONS = {
  platforms: Layers,
  ai: Brain,
  security: ShieldCheck,
  blockchain: Boxes,
  banking: Landmark,
  cauracademy: GraduationCap,
};

const Products = ({ t }) => {
  return (
    <section id="services" className="relative py-20 sm:py-24 lg:py-28" data-testid="products">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="kicker-mono mb-3">{t.products.kicker}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-[650] tracking-tight text-white" data-testid="products-title">
            {t.products.title}
          </h2>
          <p className="mt-4 text-white/70 text-base sm:text-lg">{t.products.subtitle}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.products.items.map((item, i) => {
            const Icon = ICONS[item.id] || Layers;
            const slug = SERVICE_ROUTES[item.id];
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08, ease: [0.2, 0.8, 0.2, 1] }}
                whileHover={{ y: -6 }}
                className="gradient-border h-full"
                data-testid={`product-card-${item.id}`}
              >
                <div className="inner h-full p-6 sm:p-7 flex flex-col">
                  <div className="flex items-center justify-between mb-5">
                    <div className="h-11 w-11 rounded-xl bg-[rgba(5,126,243,.12)] border border-[rgba(5,126,243,.35)] flex items-center justify-center text-[rgb(var(--brand-electric))]">
                      <Icon size={22} />
                    </div>
                    <span className="kicker-mono text-white/40">{String(i + 1).padStart(2, '0')}</span>
                  </div>
                  <h3 className="font-display text-xl lg:text-[22px] font-[650] text-white tracking-tight">{item.name}</h3>
                  <p className="mt-2 text-white/70 text-sm">{item.short}</p>
                  <ul className="mt-5 space-y-2.5 flex-1">
                    {item.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2 text-sm text-white/80">
                        <Check size={15} className="mt-0.5 text-[rgb(var(--brand-electric))] shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={`/servicios/${slug}`}
                    className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[rgb(var(--brand-electric))] hover:text-white transition-colors"
                    data-testid={`product-learn-more-${item.id}`}
                  >
                    {t.products.learn_more} <ArrowUpRight size={15} />
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Products;
